import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EReorderOffersActionTypes {
  ReorderOffers = 'REORDER_OFFERS',
}

interface IReorderOffersPayload {
  fromIndex: number;
  toIndex: number;
}

export type TReorderOffers = ITypedReduxAction<EReorderOffersActionTypes.ReorderOffers, IReorderOffersPayload>;

export const reorderOffers = actionGenerator<EReorderOffersActionTypes.ReorderOffers, IReorderOffersPayload>(
  EReorderOffersActionTypes.ReorderOffers,
);
